import { Loader } from 'components/loader';
import { TileListWrapper } from 'dsilo-ui-components';
import { TileListWrapperV1 } from 'dsilo-ui-components';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PUBLIC_PATH } from '../../constants';
import adobeLogo from '../../images/adobe-pdf-icon.png';
import {
  archivedData, bulkAssign,
  changeAssigneeRequest, checkForTraining, clearPDFData, clearReduxDataOfCurrentComponent, deleteContract, deleteContractPDFAction,
  downloadAnnotations, downloadContractPDFAction, downloadSheet, duplicatesGetRequest, duplicatesMoveRequest, executeWorkFlow, getContractDataById,
  getDataModelById, getDeletedDoc, getMembersList, getModelData, getModelDataDropDown, getNextRespondent, hideSuccessMsg, initWorkFlow,
  restoreDeleteDoc, serviceBusStatusUpdateTileList, updateDataModelData, updateModelStatus, otherDocMove, getGroups, processAgain,
  getWorkflowById, setDataToLocalDB, getCognitiveSearchData, getCurrentStepRespondents, getPDFForSupportingDocuments, getPDFForOtherDoc,
  reInitiateWorkflow, getPDFForAllOtherDoc, executeJob, downloadSheetBulkExcelOpportunity, getObligationTableData
} from '../../store/actions';

const TileListComponent = (props) => {
  console.log(props, 'props')

  const isNewV1Theme = props?.appConfiguration?.theme?.type === "v1.1";

  return <div>
    {isNewV1Theme ?
      <TileListWrapperV1
        loader={<Loader />}
        PUBLIC_PATH={PUBLIC_PATH}
        adobeLogo={adobeLogo}
        {...props}
      /> :
      <TileListWrapper
        loader={<Loader />}
        PUBLIC_PATH={PUBLIC_PATH}
        adobeLogo={adobeLogo}
        {...props}
      />
    }
  </div>;
};

const mapDispatchToProps = {
  updateModelStatus,
  getCognitiveSearchData,
  getCurrentStepRespondents,
  getModelData,
  deleteContractPDFAction,
  deleteContract,
  hideSuccessMsg,
  downloadAnnotations,
  clearPDFData,
  downloadSheet,
  updateDataModelData,
  getDataModelById,
  checkForTraining,
  downloadContractPDFAction,
  getModelDataDropDown,
  getContractDataById,
  serviceBusStatusUpdateTileList,
  clearReduxDataOfCurrentComponent,
  archivedData,
  getDeletedDoc,
  restoreDeleteDoc,
  getMembersList,
  bulkAssign,
  changeAssigneeRequest,
  getNextRespondent,
  executeWorkFlow,
  reInitiateWorkflow,
  duplicatesGetRequest,
  duplicatesMoveRequest,
  initWorkFlow,
  otherDocMove,
  getGroups,
  processAgain,
  getWorkflowById,
  setDataToLocalDB,
  getPDFForSupportingDocuments,
  getPDFForOtherDoc,
  getPDFForAllOtherDoc,
  executeJob,
  downloadSheetBulkExcelOpportunity,
  getObligationTableData
};

const mapStateToProps = state => {
  return {
    appConfig: state.appConfig.app,
    apps: state.app.app,
    login: state.login,
    user: state.user,
    formData: state.form,
    contractAnnotations: state.contractAnnotations,
    model: state.model,
    members: state.appConfig.members,
    chart: state.chart,
    appConfiguration: state.form.document?.appConfig,
		jobStore: state.jobs
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TileListComponent));
